// hooks/useWhatsappActivityListData.ts
import { getWhatsappActivity } from '@api/services/analytics.service';
import useDataQuery from '@hooks/use-data-query';
import { useMemo } from 'react';

const useWhatsappActivityListData = (startDate: string, endDate: string) => {
    const query = useDataQuery(['whatsapp-activity', startDate, endDate], () =>
        getWhatsappActivity(startDate, endDate)
    );

    const data = useMemo(() => query.data || [], [query.data]);

    return {
        data,
        isLoading: query.isLoading,
    };
};

export default useWhatsappActivityListData;
